module.exports = __webpack_public_path__ + "static/media/Univers-Condensed.68506a29.otf";